import { Button } from '../common/button';
import React from 'react';
import { Translate } from '~/i18n';
import { WhatsAppShareIcon } from '~/svgs';
import cn from 'classnames';

interface RequestFooterProps {
   cancelBtnHandler?: () => void;
   cancelBtnLabel?: string;
   fwdBtnHandler: () => void;
   fwdBtnLabel?: string;
   fwdBtnDisabled?: boolean;
   loading?: boolean;
}

export const RequestFooter = ({
   cancelBtnHandler,
   cancelBtnLabel,
   fwdBtnHandler,
   fwdBtnLabel,
   fwdBtnDisabled,
   loading,
}: RequestFooterProps) => {
   return (
      <div
         className={cn('w-full fixed left-0 bottom-0 z-[50]')}
         style={{ boxShadow: '0 -5px 5px -5px #ccc' }}>
         <div className="w-full flex justify-around md:justify-between items-center bg-white z-[50] py-5 lg:px-20 flex-wrap ">
            <div>
               <a
                  className="flex items-center gap-4 text-primary"
                  target="_blank"
                  rel="noreferrer"
                  href={`https://wa.me/966535638583/?text=`}>
                  <WhatsAppShareIcon />
                  <Translate id="profile:need help" />
               </a>
            </div>
            <div className="flex items-end justify-end gap-4">
               {cancelBtnHandler ? (
                  <Button onClick={() => cancelBtnHandler?.()} theme="outline-primary">
                     {cancelBtnLabel || <Translate id="common:back" />}
                  </Button>
               ) : null}
               {fwdBtnHandler ? (
                  <Button
                     type="submit"
                     theme="primary"
                     onClick={() => fwdBtnHandler?.()}
                     disabled={loading || fwdBtnDisabled}
                     loading={loading}>
                     {fwdBtnLabel || <Translate id="common:next" />}
                  </Button>
               ) : null}
            </div>
         </div>
      </div>
   );
};
